<template>
  <router-view #="{ Component }">
    <a-config-provider
      :theme="{
        token: {
          colorPrimary: store.themeColor
        }
      }"
    >
      <component :is="Component" />
    </a-config-provider>
  </router-view>
</template>
<script setup>
import { userStore } from '@/store/user';
const store = userStore();
document.addEventListener(
  'touchstart',
  function (event) {
    event.preventDefault(); //阻止默认行为
  },
  { passive: false }
);
</script>
